import { type WatchQueryFetchPolicy } from '@apollo/client'
import { useBusinessIdPathParam } from 'lib/navigation/hooks/useBusinessIdPathParam/useBusinessIdPathParam'
import { useGatedQuery } from 'lib/hooks/useGatedQuery/useGatedQuery'
import { BusinessHookDocument } from './useBusiness.graphql'

interface UseBusinessArgs {
  fetchPolicy?: WatchQueryFetchPolicy
}

export const useBusiness = ({ fetchPolicy }: UseBusinessArgs = {}) => {
  const businessId = useBusinessIdPathParam()
  const { data, previousData, loading } = useGatedQuery(BusinessHookDocument, businessId, {
    fetchPolicy,
    variables: { businessId },
  })

  return {
    loading,
    business: data?.business || previousData?.business || undefined,
  }
}
